<div class="estimation-holder">
	<div class="box">
		<div class="icon">
			@if (tradable?.getLogo()) {
				<img
					[src]="tradable.getLogo()"
					(error)="img.src = tradable.getDefaultLogo()"
					alt="{{ 'logo_alt_text' | translate }}"
					#img />
			} @else {
				<svg-inline src="/assets/images/web3-icon-placeholder.svg" alt="icon" />
			}
		</div>
		<div class="amount-section">
			<p class="received">{{ "prefix_you_will_receive" | translate }}</p>

			<p class="amount">
				@if (tradable?.getAssetSymbol()) {
					{{ amount | tradable_precision_symbol: { id: tradable.getId(), ignorePrecision: true } }}
				} @else {
					{{ amount }} {{ "web3_symbol" | translate }}
				}
			</p>
		</div>
	</div>
	<div class="estimation-description">
		{{ "web3_signup_text_guaranteed" | translate }}
	</div>
</div>
